import React, { useState } from 'react';
import styles from './PrivacyOptions.module.css';

const PrivacyOptions = ({ onNext, onPrev }) => {
  const [profileVisibility, setProfileVisibility] = useState('Private');
  const [contactVisibility, setContactVisibility] = useState('Limited');
  const [consentDataTraining, setConsentDataTraining] = useState('Allow');

  const handleNext = () => {
    // Logic to save data goes here later
    onNext();
  };

  return (
    <div className={styles.card}>
      <div className={styles.leftSection}>
        <label>Profile Visibility</label>
        <select
          value={profileVisibility}
          onChange={(e) => setProfileVisibility(e.target.value)}
        >
          <option value="Private">Private</option>
          <option value="Limited">Limited</option>
          <option value="Public">Public</option>
        </select>

        <label>Contact Information Visibility</label>
        <select
          value={contactVisibility}
          onChange={(e) => setContactVisibility(e.target.value)}
        >
          <option value="Private">Private</option>
          <option value="Limited">Limited</option>
          <option value="Public">Public</option>
        </select>

        <label>Consent to Data Training</label>
        <select
          value={consentDataTraining}
          onChange={(e) => setConsentDataTraining(e.target.value)}
        >
          <option value="Allow">Allow</option>
          <option value="Disallow">Disallow</option>
        </select>
      </div>

      <div className={styles.rightSection}>
        <h3>Privacy Options</h3>
        <ul className={styles.privacyDetails}>
          <li>
            <strong>Private:</strong> Profile not searchable; accessed only via direct link.
          </li>
          <li>
            <strong>Limited:</strong> Basic info searchable; full contact requires permission.
          </li>
          <li>
            <strong>Public:</strong> Fully searchable; agents and brokers may contact directly.
          </li>
        </ul>
      </div>
    </div>
  );
};

export default PrivacyOptions;
